/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type FC } from 'react';

import faviconUrl from './assets/abrain-favicon.ico';

import styles from './abrain-favicon.module.less';

/** 登录卡片品牌区：小图标 + 加粗文字，避免放大 favicon 发糊 */
export const AbrainFavicon: FC = () => (
  <div className={styles.wrap}>
    <img src={faviconUrl} alt="" className={styles.icon} />
    <span className={styles.wordmark}>Abrain</span>
  </div>
);
